module.exports = __webpack_public_path__ + "img/u95.bac3cf4a.png";